import { createActions } from 'reduxsauce';

export interface IAdminRecipient {
  id: string;
  name: string;
  legal_name: string;
  photo_id: string;
  public_fundraising_query_str?: string | null;
}

export interface IAdminPartner {
  id: number;
  name: string;
}

export interface IAdminsState {
  data: IAdminsData | null;
  adminDetail: IAdmins | null;
  isLoading: boolean;
  error: string | null;
  OBCheck: IAdminsOBCheck | null;
  recipients: IAdminRecipient[] | null;
  selectedRecipient: IAdminRecipient | null;
  stripeOnboardingCalled: boolean;
  activeRole: string;
  partners: IAdminPartner[] | null;
  screenLoading: boolean;
}
export interface IAdminsData {
  admin_users: IAdmins[];
  adminCreated?: any;
}

export enum OnboardingStatusOpts {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  REQUIREMENTS_PENDING = 'REQUIREMENTS_PENDING',
  COMPLETE = 'COMPLETE',
}

type OnboardingStatus = `${OnboardingStatusOpts}`;

export interface IAdminsOBCheck {
  onboarding_status: OnboardingStatus;
  is_primary_contact: boolean;
  has_primary_contact: boolean;
  is_stripe_authorized: boolean;
  is_tos_accepted: boolean;
  onboarding_form_complete: boolean;
  primary_contact: { name: string | null; email: string | null } | null;
  has_stripe_transactions: boolean;
}

export interface IAdminsOB {
  recipient_id: string;
  onboarding_status: OnboardingStatus;
}

export type PositionCategory = 'CAMPAIGN_MANAGER' | 'COMPLIANCE' | 'OTHER';

export interface IAdmins {
  id: string;
  email: string;
  admin_status: string;
  first_name: string;
  last_name: string;
  role_type: string;
  resource_id: string;
  resource_name: string;
  resource_access: object;
  role_names: string[];
}

export interface AdminBodyProps {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  position_category: string;
  role_type: string;
  subscription_level: string;
  is_primary_contact: boolean;
  partners: { id: string; name: string }[];
  recipients: { id: string; name: string }[];
}

export interface IAdminUserUpdate {
  first_name?: string;
  last_name?: string;
  email?: string;
  status?: string;
  phone_number?: string;
  position_category?: string;
  tos_accepted?: string;
}

export interface IAdminUserAccessUpdate {
  admin_user_id: string;
  existing_role_types: string[];
  active_role: string;
  role_type: string;
  partners?: { id: string; name: string }[];
  recipients?: { id: string; name: string }[];
}

export interface AdminTypes {
  ADMINS: 'ADMINS';
  ADMINS_PARTNERS_SUCCESS: 'ADMINS_PARTNERS_SUCCESS';
  ADMIN_CREATED_SUCCESS: 'ADMIN_CREATED_SUCCESS';
  ADMIN_DETAIL_SUCCESS: 'ADMIN_DETAIL_SUCCESS';
  ADMINS_ACTIVE_ROLE: 'ADMINS_ACTIVE_ROLE';
}

const { Types, Creators } = createActions<AdminTypes>({
  admins: ['data'],
  adminsPartnersSuccess: ['partners'],
  adminCreatedSuccess: ['data'],
  adminDetailSuccess: ['data'],
  adminsActiveRole: ['role'],
});

export { Types };

export default Creators;
